"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "updateQuantityCart", {
    enumerable: true,
    get: ()=>updateQuantityCart
});
const _graphqlRequest = require("graphql-request");
const _checkoutFragment = require("../fragments/checkout-fragment");
const updateQuantityCart = (0, _graphqlRequest.gql)`
    mutation UpdateQuantity(
        $retailerId: ID!
        $checkoutId: ID!
        $itemId: ID!
        $quantity: Int!
    ) {
        updateQuantity(
            retailerId: $retailerId
            checkoutId: $checkoutId
            itemId: $itemId
            quantity: $quantity
        ) {
            ...checkoutFragment
        }
    }
    ${_checkoutFragment.CHECKOUT_FRAGMENT}
`;
